import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import type { Provider } from '@angular/core';
import { Optional, SkipSelf } from '@angular/core';

import { ContextTooltipOverlay } from './directives/context-tooltip-overlay';
import { ContextTooltipOverlayContainer } from './directives/context-tooltip-overlay-container';

export const OVERLAY_PROVIDERS: Provider[] = [
  {
    provide: ContextTooltipOverlay,
    useFactory: (overlay: Overlay, contextOverlay?: ContextTooltipOverlay) =>
      contextOverlay || overlay,
    deps: [Overlay, [SkipSelf, Optional, ContextTooltipOverlay]],
  },
  {
    provide: ContextTooltipOverlayContainer,
    useFactory: (
      overlayContainer: OverlayContainer,
      contextContainer?: ContextTooltipOverlayContainer,
    ) => contextContainer || overlayContainer,
    deps: [OverlayContainer, [SkipSelf, Optional, ContextTooltipOverlayContainer]],
  },
];
